/* eslint-disable confluence-feature-gating/no-preconditioning */
import type { ConfluenceSubmitPromptOnPageCreateCommandProperties } from '@atlassian/rovo-content-bridge-api-commands';
import { CommandHandler, type PassThroughCommandProps } from '@atlassian/editor-rovo-bridge';

import { fg } from '@confluence/feature-gating';

import { log } from '../utils/aifc-logging.ts';
import type { ExtraCommandProps } from '../RovoBridgeCommandListener.tsx';

export class SubmitPromptCommandHandler extends CommandHandler<
	ConfluenceSubmitPromptOnPageCreateCommandProperties,
	void
> {
	constructor(
		props: PassThroughCommandProps,
		private extraProps: Pick<ExtraCommandProps, 'generateAIHeaderImage'>,
	) {
		super(props);
	}

	async execute(payload: ConfluenceSubmitPromptOnPageCreateCommandProperties): Promise<void> {
		log('handle confluence-prompt-submit-on-page-create-command');
		if (
			this.extraProps.generateAIHeaderImage &&
			fg('aifc_header_image_pseudo_title_enabled') &&
			// Skip pseudo title path when quick image generation is enabled,
			// as image generation will be triggered from the real title in onStream instead
			!fg('cc_page_experiences_quick_aifc_image_generation')
		) {
			await this.extraProps.generateAIHeaderImage({
				adfContent: payload.userPrompt,
			});
		}
	}
}
